import { Component } from '@angular/core';
import { AssetsDataService } from 'src/services/assets-data.service';

@Component({
  selector: 'app-layout-condensed',
  templateUrl: './layout-condensed.component.html'
})
export class LayoutCondensedComponent { 

  constructor (public assetsDataService: AssetsDataService) {}

}
